import { createReducer, on } from '@ngrx/store';
import { FeedbacksActions, RouterActions, AppActions } from '@actions/index'
import { FeedbackModel } from '@models/index'

export interface State {
    feedbacks: FeedbackModel [];
    total: number;
    filterTotal: number;
    isExcecutingTask: boolean;
    error: string;
}

const initialState: State = {
    feedbacks: [],
    total: 0,
    filterTotal: 0,
    isExcecutingTask: true,
    error: ''
};

export const reducer = createReducer(
    initialState,
    on(FeedbacksActions.searchFeedbacksSuccess, (state, { data, total }) => ({
        ...state,
        feedbacks: data,
        filterTotal: total,
        isExcecutingTask: false
    })),
    on(FeedbacksActions.getTotalFeedbacksByLocationSuccess, (state, { total }) => ({ ...state, total: total })),
    on(FeedbacksActions.feedbackError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
    on(AppActions.clearState, (state) => {
        return ({ ...state, 
            feedbacks: [],
            total: 0,
            filterTotal: 0,
        })}),
);

export const getFeedbacks = (state: State) => state.feedbacks;
export const getTotal = (state: State) => state.total;
export const getFilterTotal = (state: State) => state.filterTotal;
export const getIsExcecutingTask = (state: State) => state.isExcecutingTask;
export const getError = (state: State) => state.error;